import type { SanityPageBuilderCallToActionListItem, SanityPageBuilderCallToActionListSection, SanityPageBuilderSection } from "@ouster/shared";
import { CallToActionListBlockView } from "~/features/blocks/inventory/call-to-action-list";
import { CallToActionListItemView, type CallToActionListItemViewProps } from "~/features/blocks/inventory/call-to-action-list/call-to-action-list-item";
import { toCraftLinkArray } from "~/features/sanity/link";
import { toCraftAsset } from "~/features/sanity/media";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderCallToActionListSection;
  };
};
type CallToActionListViewItem = Omit<CallToActionListItemViewProps, "layout" | "showLinks"> & Pick<SanityPageBuilderCallToActionListItem, "_key">;
export function SanityCallToActionListSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const showLinks = sectionContent.showLinks ?? false;
  const items = sectionContent.items?.map<CallToActionListViewItem>(item => ({
    _key: item._key,
    headline: item.headline,
    image: toCraftAsset(item.image),
    link: toCraftLinkArray(item.link),
    text: item.text
  })) ?? [];
  return <CallToActionListBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={items} mode={mode} renderItem={(item, _index, layout) => <CallToActionListItemView headline={item.headline} image={item.image} layout={layout} link={item.link} showLinks={showLinks} text={item.text} />} showLinks={showLinks} theme={theme} />;
}